// import API from "../helpers/API";
import HttpClient from "../helpers/HttpClient";
import { API_BASE_URL } from "../constants/index";

export default class RegistryService {
  // Initializing important variables
  constructor(domain) {
    // this.API = new API();
    // this.domain = process.env.API_URL; // API server domain
    this.httpClient = new HttpClient();
  }

  getCompanies(filters = {}) {
    const { page, size, search, freeSearch, sort } = filters;
    const requestOptions = {
      method: "GET",
    };
    const currentPage = page || 0;
    const rows = size || 10;
    let url = `${API_BASE_URL}/registry-service/companies?page=${currentPage}&size=${rows}`;

    if (search) {
      url = url + "&search=" + search;
    }
    if (freeSearch) {
      url = url + "&freeSearch=" + freeSearch;
    }
    if (sort) {
      url = url + "&sort=" + sort;
    }

    return this.httpClient.fetch(url, requestOptions);
  }

  createCompany(body) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
    };
    return this.httpClient.fetch(
      API_BASE_URL + `/registry-service/companies`,
      requestOptions
    );
  }
  editCompany(id, body) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(body),
    };
    return this.httpClient.fetch(
      API_BASE_URL + `/registry-service/companies/${id}`,
      requestOptions
    );
  }
  getCompany(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpClient.fetch(
      API_BASE_URL + `/registry-service/companies/${id}`,
      requestOptions
    );
  }

  deleteCompanies(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpClient.fetch(
      API_BASE_URL + `/registry-service/companies/${id}`,
      requestOptions
    );
  }
}
